var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.createShow
    ? _c("div", { staticClass: "popup" }, [
        _c(
          "div",
          { staticClass: "content", attrs: { id: "googlePhotosV2Tips" } },
          [
            _c("div", { staticClass: "title" }, [
              _c("span", [
                _vm._v(
                  _vm._s(
                    _vm.$t(
                      "language.popup.cloudExploerPopup.googlePhotosV2FolderName"
                    )
                  )
                )
              ]),
              _vm._v(" "),
              _c("div", {
                staticClass: "icon white-close dialog-close",
                on: {
                  click: function($event) {
                    _vm.createShow = false
                  }
                }
              })
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "create-content" }, [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.folderName,
                    expression: "folderName"
                  },
                  { name: "focus", rawName: "v-focus" }
                ],
                ref: "folderInput",
                attrs: {
                  type: "text",
                  maxlength: "50",
                  placeholder: _vm.$t(
                    "language.popup.cloudExploerPopup.googlePhotosV2FolderNameInput"
                  )
                },
                domProps: { value: _vm.folderName },
                on: {
                  input: function($event) {
                    if ($event.target.composing) {
                      return
                    }
                    _vm.folderName = $event.target.value
                  }
                }
              }),
              _vm._v(" "),
              _c(
                "button",
                {
                  on: {
                    click: function($event) {
                      return _vm.okDeal()
                    }
                  }
                },
                [_vm._v(_vm._s(_vm.$t("language.common.ok")))]
              )
            ])
          ]
        )
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-f84cbd4a", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f84cbd4a","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/popup/cloud_exploer_popups/google_photos_v2_create_popup.vue
// module id = null
// module chunks = 